<template>
  <div style="margin-top:30px">
    <el-form ref="form" :rules="rules" :model="form" label-width="80px">
      <el-row>
        <el-form-item label="code" prop="code" style="margin-right:15px">
          <el-input v-model="form.code" placeholder="请输入code" />
        </el-form-item>
        <el-form-item
          label="支付油点（单位分）"
          prop="payPoint"
          style="margin-right:15px"
        >
          <el-input
            v-model="form.payPoint"
            placeholder="请输入支付油点（单位分）"
          />
        </el-form-item>
        <el-form-item
          label="实际承运人用户编码"
          prop="driverCode"
          style="margin-right:15px"
        >
          <el-input
            v-model="form.driverCode"
            placeholder="请输入实际承运人用户编码"
          />
        </el-form-item>
        <el-form-item
          label="加油站编码"
          prop="gsaCode"
          style="margin-right:15px"
        >
          <el-input v-model="form.gsaCode" placeholder="请输入加油站编码" />
        </el-form-item>
        <el-form-item label="小票号" prop="banks" style="margin-right:15px">
          <el-input v-model="form.banks" placeholder="请输入小票号" />
        </el-form-item>
        <el-form-item
          label="设备号"
          prop="deviceNumber"
          style="margin-right:15px"
        >
          <el-input v-model="form.deviceNumber" placeholder="请输入设备号" />
        </el-form-item>
        <el-form-item
          label="实际承运人余额（单位分）"
          prop="balanceOil"
          style="margin-right:15px"
        >
          <el-input
            v-model="form.balanceOil"
            placeholder="请输入实际承运人余额（单位分）"
          />
        </el-form-item>
        <el-form-item
          label="商户名称"
          prop="merchantName"
          style="margin-right:15px"
        >
          <el-input v-model="form.merchantName" placeholder="请输入商户名称" />
        </el-form-item>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">取 消</el-button>
      <el-button type="primary" @click="funcSubmit">确 定</el-button>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
export default {
  name: "GasStationPaymentAdd",
  data() {
    return {
      form: {
        code: "",
        payPoint: "",
        driverCode: "",
        gsaCode: "",
        banks: "",
        deviceNumber: "",
        balanceOil: "",
        merchantName: ""
      },
      rules: {
        code: [
          { required: true, message: "请输入code", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        payPoint: [
          {
            required: true,
            message: "请输入支付油点（单位分）",
            trigger: "blur"
          },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        driverCode: [
          {
            required: true,
            message: "请输入实际承运人用户编码",
            trigger: "blur"
          },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        gsaCode: [
          { required: true, message: "请输入加油站编码", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        banks: [
          { required: true, message: "请输入小票号", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        deviceNumber: [
          { required: true, message: "请输入设备号", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        balanceOil: [
          {
            required: true,
            message: "请输入实际承运人余额（单位分）",
            trigger: "blur"
          },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        merchantName: [
          { required: true, message: "请输入商户名称", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ]
      }
    };
  },
  created() {},
  methods: {
    //提交
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const data = this.form;
          const rLoading = this.openLoading();
          request({
            url: "/ntocc-basic-api/gasStationPayment",
            method: "post",
            params: data
          })
            .then(response => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
              this.$emit("fatherAddMethod");
            })
            .then(() => this.$refs["form"].resetFields());
        } else {
          return false;
        }
      });
    },
    //取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "add");
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
